var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddRecolector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2128 4.997C17.028 7.74899 15.139 9.994 13.0652 9.994C10.9914 9.994 9.09905 7.74951 8.91759 4.997C8.72906 2.13413 10.5672 0 13.0652 0C15.5631 0 17.4013 2.18619 17.2128 4.997Z",
    fill: "#889AAE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0654 13.3203C8.96496 13.3203 4.80324 15.8188 4.03311 20.5347C3.93885 21.1031 4.23153 21.6486 4.77072 21.6486H21.3606C21.8998 21.6486 22.191 21.1031 22.0982 20.5347C21.3276 15.8188 17.1659 13.3203 13.0654 13.3203Z",
    fill: "#889AAE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.64062 6.65625V12.4913",
    stroke: "#889AAE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.27874 9.57812H1",
    stroke: "#889AAE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddRecolector);
export default __webpack_public_path__ + "static/media/addRecolector.9a0840e2287a3d59ded1d6c8bbef3896.svg";
export { ForwardRef as ReactComponent };